import {
    Card,
    CardApiEntity,
} from 'billing/modules/CreditCardModule/CreditCardModule.types';
import creditCardTypes from 'system/libs/creditCardTypes';
import dateTime from 'system/libs/dateTime';
import { ApiHelper } from 'utils/apiHelper';

export function getCreditCardApi(pid: string) {
    return {
        async loadData() {
            const data = await ApiHelper.rpcCall<[CardApiEntity | undefined]>({
                url: `/api/v1/projects/${pid}/billing/card/bind`,
            });

            const card = data[0];

            return card && deserialize(card);
        },

        removeCard(bindId: string) {
            return ApiHelper.rpcCall({
                url: `/api/v1/projects/${pid}/billing/card/bind?bind_id=${bindId}`,
                method: 'DELETE',
            });
        },
    };
}

function deserialize(card: CardApiEntity): Card {
    const { description: number } = card;
    const expirationDate = getExpirationDate(card);
    return {
        ...card,
        number: number.replace(/^(.+)(\d{4})$/i, (a, b, c) => {
            return c;
        }),
        type: creditCardTypes.getCardInfoByNumber(number)?.type as Card['type'],
        expired:
            expirationDate && expirationDate.getTime() <= new Date().getTime(),
        expirationDate: expirationDate
            ? dateTime.format(expirationDate, 'MM/yy')
            : '',
    };
}

function getExpirationDate(card: CardApiEntity) {
    let exp_date: Date | undefined;

    if (card.exp_date) {
        exp_date = new Date();
        const date = card.exp_date
            .split(card.exp_date.includes('.') ? '.' : '/')
            .map(Number);

        exp_date.setFullYear(date[1]);
        exp_date.setMonth(date[0] - 1);
    }

    return exp_date;
}
